module.exports = __webpack_public_path__ + "img/干货.41e344b1.png";